//imports
import React, { useEffect, useRef, useState } from "react";

import { Box, Grid, Container } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";

//sass
import "Core/views/login/login.scss";


//components
import { Form, Input, Loading, Button } from "Components";
import LoginLogo from "../common/LoginLogo";
import ChatWithSupport from "../common/ChatWithSupport";
import { NotificationManager } from 'Components/Notifications';

import ToggleLanguage from "../../../components/ToggleLanguage";
import SalesForceApi from 'Core/salesForceApi';
import { ErrorHandlerLogin } from "Core/data/Helpers";

import { forgotPasswordRequest, reset } from './redux/slice'
//actions
import {
  clearRedux,
  getResellerInfo,
} from "Redux/actions";


const ForgotPasswordView = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { messages } = useIntl();
  const frmForgotPassword = useRef();
  let { reseller } = useParams();

  //http://localhost:40000/resetPassword?email=ronalcamilo@gmail.com&confirmationCode=194451&action=forgotPassword

  const { loading, error, result, showConfirm } = useSelector((state) => state.forgotPasswordRedux);
  const { current_reseller, reseller_was_validated } = useSelector((state) => state.resellerRedux)

  const urlImgLogo = current_reseller ? current_reseller?.loginCompanyLogo : "/assets/images/verticalLogo.png";

  const [username, setUsername] = useState("");

  useEffect(() => {
    if (result) {
      NotificationManager.success(
        messages[`forgotPassword_sucessMessage`],
        messages['success'],
        4000,
        null,
        null,
        'Success',
      );

      navigate('/login');
    }
  }, [result])


  useEffect(() => {
    return () => {
      dispatch(reset());
    }
  }, [])


  useEffect(() => {
    if (reseller) {
      dispatch(getResellerInfo("key", reseller));
    }
  }, [reseller]);


  const validateErrorMessage = (label) => {
    switch (label) {
      case "Error: Username/client id combination not found.":
        return messages["forgotPassword_errorMesaggeUserNoFound"];
      default:
        return ErrorHandlerLogin(label);
    }
  };


  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      className="all-space-container"
    >
      <Grid
        item
        xs={12}
        lg={5}
        style={{
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Box
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "end",
            margin: "20px 25px 0 0px",
          }}
        >
          <Box>
            <ToggleLanguage className="btn-white" />
          </Box>
        </Box>
        <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
          <div className="background-white-login" style={{ width: "500px" }}>
            <Container className="form-login-container">
              {reseller_was_validated && <LoginLogo urlImgLogo={urlImgLogo} />}
              {
                error &&
                <div className="form-item card-error-login">
                  <p className="txt-card-error-login">
                    {
                      // If forgot password and is a reseller show a different message
                      current_reseller &&
                        ErrorHandlerLogin(error) === "forgotPassword_userNoMigrated"
                        ? messages["forgotPassword_userNoMigratedReseller"]
                        : messages[ErrorHandlerLogin(error)] || validateErrorMessage(error)
                    }
                  </p>
                </div>
              }

              <Form
                ref={frmForgotPassword}
                onValidSubmit={() => {
                  dispatch(forgotPasswordRequest({ username }));
                }}
              >
                <div>
                  <p
                    style={{
                      fontSize: "16px",
                      margin: "30px 0 0 0",
                      fontWeight: "400",
                    }}
                  >
                    {messages["forgotPassword_title"]}
                    <span className="text-danger"> *</span>
                  </p>
                  <Input
                    id="txtEmail"
                    type="text"
                    placeholder={messages["forgotPassword_email"]}
                    value={username}
                    onChange={(text) => {
                      setUsername(text);
                    }}
                    required
                    requiredMessage={messages["required_field"]}
                    autoFocus
                  />
                </div>
                <div style={{ paddingTop: 10 }}>
                  {
                    loading ?
                      <div className="loading-area">
                        <Loading />
                      </div>
                      : (
                        showConfirm ?
                          (
                            <Button
                              id="btnContinueConfirm"
                              onClick={(e) => {
                                e.preventDefault();
                                navigate('/login')
                              }}
                              className="btn btn-blue btn-block"
                            >
                              <FormattedMessage id="back" />
                            </Button>
                          )
                          : (
                            <Button
                              id="btnContinue"
                              className="btn btn-blue btn-block"
                              disabled={loading}
                              onClick={(e) => {
                                e.preventDefault();
                                frmForgotPassword.current.submit();
                              }}
                            >
                              <FormattedMessage id="continue" />
                            </Button>
                          )

                      )}
                </div>
              </Form>
              {
                !current_reseller && reseller_was_validated &&
                <div style={{ marginTop: 10 }}>
                  <ChatWithSupport />
                </div>
              }
            </Container>

          </div>
        </div>

        <Box m="25px">
          <div style={{ paddingTop: 10 }}>
            <Button
              id="btnBack"
              style={{
                fontSize: "15px",
                fontWeight: "400",
                position: "relative",
              }}
              type="link"
              className="login-page-link"
              url={
                current_reseller?.key && location.pathname.includes("reseller")
                  ? `/reseller/${current_reseller?.key}`
                  : "/login"
              }
            >
              <FormattedMessage id="forgotPassword_back" />
            </Button>
          </div>
        </Box>
      </Grid>
      <Grid item xs={12} lg className="all-space-container">
        <div
          className="login_bg"
          style={{
            backgroundImage: (!current_reseller?.loginBackgroundImage && current_reseller?.loginBackgroundColor) ? `none`
              : `url(${current_reseller?.loginBackgroundImage ||
              "/assets/images/loginbg-dark.png"
              })`,
            backgroundColor: current_reseller?.loginBackgroundImage ? "transparent" : (current_reseller?.loginBackgroundColor || "transparent")
          }}
        />
      </Grid>
      {
        !current_reseller && reseller_was_validated &&
        <SalesForceApi />
      }
    </Grid>
  );
};

export default ForgotPasswordView;
